import { combineReducers } from 'redux';

import { AppState } from './state';
import { layoutReducer } from 'store/features/layout/reducers';
import { authReducer } from './features/auth/reducers';

/**
 *
 * Combine all reducers in this file and export the combined reducers.
 *
 * @return {object} combined reducers
 */
const createReducers = () =>
  combineReducers<AppState>({
    auth: authReducer,
    layout: layoutReducer
  });

export default createReducers;
